// extracted by mini-css-extract-plugin
export default {"wrapperPage":"PrivacyPolicy_wrapperPage__SbKvP","title":"PrivacyPolicy_title__wmjRK","content":"PrivacyPolicy_content__WyvU1"};